import React, { CSSProperties, useEffect, useState } from "react";
import ItemRevisionColorModel from "../../../models/ItemRevisionColorModel";

interface IProps {
    onClick: (itemColor: ItemRevisionColorModel) => void
    itemColor: ItemRevisionColorModel
}

const ItemColorControl: React.FC<IProps> = ({ onClick, itemColor }) => {
    const [itemRevisionColor, setItemRevisionColor] = useState(itemColor)

    useEffect(() => {
        setItemRevisionColor(itemColor)
    }, [itemColor])

    if (!itemRevisionColor)
        return <></>

    var style: CSSProperties = {
        backgroundColor: itemRevisionColor.color.colorCode
    }

    if (itemRevisionColor.alternativeColorCode)
        style.backgroundColor = itemRevisionColor.alternativeColorCode

    if (itemRevisionColor.color.textColorCode)
        style.color = itemRevisionColor.color.textColorCode

    return (
        <div className='item-color' style={style} onClick={() => onClick(itemColor)}>{itemRevisionColor.color.abbreviation}</div>
    );
}
export default ItemColorControl;